
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Setting, SettingState, TibboDataType, FeatureType,
} from '@appblocks/codegeneration/types';
import ZephyrUtils from '@appblocks/platforms/ZephyrUtils';

export default class BaseGPIOPeripheral extends BaseFeature {
    constructor() {
        super();
        this.singleInstance = false;
        this.featureType = FeatureType.PERIPHERAL;
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.INTEGER,
                required: true,
                default: 'peripheral',
            },
            {
                id: 'ENABLED',
                name: 'Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'BUILTIN',
                name: 'Built In',
                settingType: SettingType.BOOLEAN,
                readonly: true,
                default: '0',
            },
            {
                id: 'BUILTINID',
                name: 'Built In ID',
                settingType: SettingType.HIDDEN,
                readonly: true,
                default: '',
            },
            {
                id: 'PIN',
                name: 'Pin',
                settingType: SettingType.PIN,
                required: true,
                meta: 'GPIO',
                default: '',
            },
            {
                id: 'PULL',
                name: 'Pull',
                settingType: SettingType.OPTION,
                default: '',
                required: true,
                options: [
                    {
                        name: 'None',
                        value: '',
                    },
                    {
                        name: 'Down',
                        value: 'down',
                    },
                    {
                        name: 'Up',
                        value: 'up',
                    },
                ],
            },
            {
                id: 'ACTIVE',
                name: 'Active Level',
                settingType: SettingType.OPTION,
                default: '0',
                required: true,
                options: [
                    // {
                    //     name: 'None',
                    //     value: '',
                    // },
                    {
                        name: 'Active High',
                        value: '1',
                    },
                    {
                        name: 'Active Low',
                        value: '0',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getFlags(): string {
        return ZephyrUtils.getFlags(this);
    }
}
